import { useWizard } from '../wizardContext';

const STEP_LABELS: Record<number, string> = {
  1: 'Modelo',
  2: 'Seus dados',
  3: 'Seminovo',
  4: 'Simulação',
  5: 'Resumo',
};

export const Stepper = () => {
  const { state, goToStep } = useWizard();
  const all = [1, 2, 3, 4, 5];
  const applicable = (n: number) => state.hasTradeIn || n !== 3;
  const total = all.length;

  return (
    <>
      <nav className="lpfs-stepper" aria-label="Etapas da simulação">
        {all.map((n, i) => {
          const isActive = n === state.step;
          const isSkipped = !applicable(n);
          const isDone = n < state.step && applicable(n);
          const cls = ['lpfs-step', isActive && 'is-active', isDone && 'is-done', isSkipped && 'is-skipped']
            .filter(Boolean)
            .join(' ');
          return (
            <div className={cls} key={n}>
              <button
                type="button"
                className="lpfs-step-btn"
                aria-current={isActive ? 'step' : undefined}
                onClick={isDone ? () => goToStep(n) : undefined}
              >
                <span className="lpfs-step-dot">{isDone ? '✓' : n}</span>
                <span className="lpfs-step-label">
                  {STEP_LABELS[n]}
                  {isSkipped && <span className="lpfs-step-opt">opcional</span>}
                </span>
              </button>
              {i < all.length - 1 && <span className="lpfs-step-line" />}
            </div>
          );
        })}
      </nav>

      <div className="lpfs-stepper-mobile">
        <div className="lpfs-sm-label">
          <span>
            <span className="lpfs-sm-step">
              Passo {state.step} de {total}
            </span>{' '}
            · {STEP_LABELS[state.step]}
          </span>
        </div>
        <div className="lpfs-progress">
          <span style={{ width: `${(state.step / total) * 100}%` }} />
        </div>
      </div>
    </>
  );
};
